import { defineComponent as _defineComponent } from 'vue'
export interface Props {
  /**
   * The currency amount to be displayed.
   */
  value: Nullable<number>;
  /**
   * The currency of the provided amount. Defaults to `usd`.
   */
  currency?: currencies.Currency;
  /**
   * The unit type of the provided amount. Defaults to `primary`.
   */
  unit?: currencies.UnitType;
  /**
   * HTML tag name to use for rendered DOM element.
   */
  tag?: string;
}


import { computed } from 'vue';

import { isNumber } from '@tools/type-guards';
import * as currencies from '@utils/currencies';

declare module 'vue/types/vue' {
  export interface Vue {
    DisplayTextCurrency: ComponentWithProps<Props>;
  }
}

const __default__ = { name: 'DisplayTextCurrency' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    value: null,
    currency: { default: 'usd' },
    unit: { default: 'primary' },
    tag: { default: 'span' }
  },
  setup(__props: any) {

const props = __props as { value: Nullable<number>, currency: currencies.Currency, unit: currencies.UnitType, tag: string };

/**
 * `DisplayTextCurrency` component properties.
 */


const displayValue = computed(() => {
  if (!isNumber(props.value)) return '--';

  let amount: number;

  if (props.unit === 'smallest') {
    amount = currencies.convertUnit(props.value, props.currency, 'primary');
  } else {
    amount = props.value;
  }

  return currencies.format(amount, props.currency);
});

return { __sfc: true,props, displayValue }
}

})